import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { BadgeComponent } from '../../../components/badge/badge.component';
import { MessagesCounterService } from '../../../services/messages/messages-counter.service';

/**
 * This component handles putting the number on the envelope in the menu based on the number of unread messages.
 */
@Component({
  selector: 'td-wb-messages-counter',
  templateUrl: 'messages-counter.component.html',
  imports: [
    TranslateDirective,
    BadgeComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessagesCounterComponent implements OnInit, OnDestroy {
  messagesCounter: number;
  private messageCounterSubscription: Subscription;

  constructor(private messagesCounterService: MessagesCounterService,
              private changeDetectorRef: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.messageCounterSubscription = this.messagesCounterService.onMessagesCounterUpdate.subscribe((counter: number): void => {
      this.messagesCounter = counter;
      this.changeDetectorRef.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this.messageCounterSubscription?.unsubscribe();
  }
}
